import {
  createCellActions,
  createCellPlainStatuses,
} from '../builder-definition/tables';

export default {
  headers: [
    {
      value: 'pageId',
      text: 'ID',
      name: 'pageId',
      width: '58px',
      hideable: false,
      sortable: false,
      isShown: true,
      ...createCellPlainStatuses({
        mapper: 'pages',
        statusProp: 'status',
      }),
    },
    {
      value: 'name',
      name: 'name',
      text: 'Name',
      width: '150px',
      hideable: false,
      sortable: false,
      isShown: true,
    },
    {
      value: 'translations.en.metaTitle',
      name: 'translations.en',
      text: 'Meta title',
      width: '250px',
      hideable: false,
      sortable: false,
      isShown: true,
    },
    {
      value: 'translations.en.metaDescription',
      name: 'translations.en.metaDescription',
      text: 'Meta description',
      width: '515px',
      hideable: false,
      sortable: false,
      isShown: true,
    },
    {
      text: 'Status',
      value: 'status',
      isHidden: true,
    },
    {
      value: 'actions',
      text: 'Actions',
      width: '60px',
      searchable: false,
      sortable: false,
      isShown: true,
      ...createCellActions({
        actionItems: (tableElement) => {
          const defaultActions = [
            {
              text: 'Unarchive',
              value: 'restore',
              prop: 'restore',
              callBack: (item, store) => {
                store.dispatch('pages/unarchive', item.mainId);
              },
            },
            {
              text: 'Archivable',
              value: 'archivable',
              prop: 'archivable',
              callBack: (item, store) => {
                store.dispatch('pages/archive', item.mainId);
              },
            },
            {
              text: 'Edit',
              value: 'editable',
              prop: 'editable',
              callBack: (item, store) => {
                store.dispatch('pages/editorDialog/openEditModal', item.pageId);
              },
            },
          ];
          const excluded = [];
          const filteredActions = defaultActions.filter(({ prop }) => {
            if (!prop) return true;

            return tableElement.actions[prop]
              ? tableElement.actions[prop]
              : false;
          });
          const finalActions = filteredActions.filter(({ value }) => !excluded.includes(value));

          return finalActions;
        },
      }),
    },
  ],
};
